// import './style.css'
import './styles/main.css'
import './styles/provelocali.css'

import Experience from './Experience/Experience.js'

//ricava il percorso assoluto dello script
const scripts= document.getElementsByTagName('script')
const path= scripts[scripts.length-1].src.split('?')[0];      // remove any ?query
const mydir= path.split('/').slice(0, -1).join('/')+'/';  // remove last filename part of path

//ricava il nome del modello della pagina TODO
const model= document.getElementById('tredcontainer').innerHTML
const defaultColor= document.getElementById('defaultColor').innerHTML
var modelA=null
var modelB=null
var modelC=null
if (document.getElementById('modelA')) { modelA= document.getElementById('modelA').innerHTML}
if (document.getElementById('modelB')) { modelB= document.getElementById('modelB').innerHTML}
if (document.getElementById('modelC')) { modelC= document.getElementById('modelC').innerHTML}
// const modelB= document.getElementById('modelB').innerHTML
// const modelC= document.getElementById('modelC').innerHTML

if (model!=''){
    const experience = new Experience({
        canvasContainer: document.querySelector('.webglContainer'),
        baseDir:mydir,
    //    listaGLB:[model]
        model:model,
        modelA:modelA,
        modelB:modelB,
        modelC:modelC,
        defaultColor:defaultColor
    
        }
    )
}
